module.exports = __webpack_public_path__ + "assets/img/18_1829_big.aa788df2.jpg";